import { render, staticRenderFns } from "./FlatSms.vue?vue&type=template&id=9de18d92&scoped=true&"
import script from "./FlatSms.vue?vue&type=script&lang=js&"
export * from "./FlatSms.vue?vue&type=script&lang=js&"
import style0 from "./FlatSms.vue?vue&type=style&index=0&id=9de18d92&lang=css&scoped=true&"
import style1 from "./FlatSms.vue?vue&type=style&index=1&id=9de18d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de18d92",
  null
  
)

export default component.exports